import { connect } from 'react-redux';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import styles from './UserNotification.module.scss';
import { getUserNotificationUnreadCount } from '../selectors/userNotificationSelectors';

interface IUserNotificationCountProps {
  userNotificationUnreadCount: number;
}

const UserNotificationCountWithoutStore = ({ userNotificationUnreadCount }: IUserNotificationCountProps) => {
  return (
    <>
      {userNotificationUnreadCount > 0 && (
        <div className={styles.UserNotificationCount}>
          {userNotificationUnreadCount > 99 ? '99+' : userNotificationUnreadCount}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: IRootState): IUserNotificationCountProps => ({
  userNotificationUnreadCount: getUserNotificationUnreadCount(state),
});

export const UserNotificationCount = connect(mapStateToProps)(UserNotificationCountWithoutStore);
